<template lang="pug">
  section.mt-header
    .wrapper-header-full
      .col.col-left
        nav.rrss
          a(href="https://www.facebook.com/mtonlinecl/")
            font-awesome-icon(:icon="['fab', 'facebook-f']")
          a(href="https://www.instagram.com/mtlatercera/")
            font-awesome-icon(:icon="['fab', 'instagram']")
          a(href="https://twitter.com/mtlatercera")
            font-awesome-icon(:icon="['fab', 'twitter']")
      .col.col-center
        h1
          a.logo-latercera(href='http://mtonline.latercera.com')
            img(src="assets/images/logos-white/mtonline.svg", alt="MT Online")
      .col.col-right
        section.papeldigital
          .col
            h2 Revisa nuestro <br> papel digital<br><strong>aquí</strong>
          .col
            .papel-wrapper
              a(href="https://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&amp;pubid=c2876e84-02c0-4037-9d8e-46c638044a4f", title="Leer Papel Digital")
                span.shadow
                img.img-fluid(src="https://edition.pagesuite-professional.co.uk/get_image.aspx?w=240&pbid=c2876e84-02c0-4037-9d8e-46c638044a4f&pnum=01&nocache=", alt="Leer Papel Digital")
    LTHeaderBar.mtmenubar
    //- SponsorHeader
</template>

<script>
  import LTHeaderBar from './LTHeaderBar'
  import SponsorHeader from './SponsorHeader'

  export default {
    name: 'mt-header',
    components: {
      LTHeaderBar,
      SponsorHeader
    },
    props: []
}
</script>

<style scoped lang="scss">
  .mtmenubar{
    background-color: rgba(0,0,0,0.05);
  }
  .wrapper-header-full{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 0 1rem;
    @media all and (max-width: 900px){
      display: none;
    }
    > .col{
      padding: 1rem 0;
    }
  }
  .papeldigital{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    &:hover{
      .papel-wrapper{
        padding-bottom: 300px;
      }
    }
    .papel-wrapper{
      padding: 2px 10px 75px 0;
      transition: all .5s cubic-bezier(.86,.03,.12,.99);
      height: 0;
      overflow: hidden;
      position: absolute;
    }
    h2{
      text-align: right;
      text-transform: uppercase;
      font-size: 16px;
      font-family: 'Open Sans', sans-serif;
      font-weight: 300;
      color: white;
      line-height: 18px;
      strong{
        font-weight: 700;
      }
    }
    a{
      display: inline-block;
      width: auto;
      position: relative;
      z-index: 3;
      &:after,
      &:before{
        background-color: white;
        box-shadow: 4px 0px 6px rgba(0,0,0,0.2);
        content: '';
        position: absolute;
        width: 100%;
      }
      &:after{
        left: 3px;
        top: 4px;
        bottom: 4px;
      }
      &:before{
        left: 7px;
        top: 8px;
        bottom: 8px;
      }
      img{
        display: block;
        position: relative;
        z-index: 2;
        box-shadow: 4px 0px 6px rgba(0,0,0,0.2);
        max-width: 190px;
      }
      .shadow{
        display: block;
        background: linear-gradient(88deg, rgba(0,0,0,0.8), rgba(255,255,255,.4) 15%, transparent 40%);
        mix-blend-mode: hard-light;
        content: '';
        position: absolute;
        z-index: 3;
        width: 100%;
        height: 100%;
      }
    }
  }
  .rrss{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    a{
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 30px;
      margin: 2px;
      border: 1px solid white;
      position: relative;
      overflow: hidden;
      &:after{
        content: '';
        background-color:  white;
        position: absolute;
        width: 100%;
        height: 100%;
        transform: scale(0);
        transition: transform .3s ease;
        border-radius: 20px;
      }
      &:hover{
        color: black;
        &:after{
          transform: scale(1);
          z-index: -1;
        }
      }
    }
  }
  .mt-header {
    > div {
      padding-top: 25px;
    }
    .col-center{
      justify-self: center;
    }
    .logo-latercera{
      width: 315px;
      margin: 0;
      img{
        display: block;
        width: 315px;
        margin: 0;
      }
    }
  }
</style>
